import { IPark } from '@/models/IPark.model';
import { IStore } from '@/models/IStore.model';
import { IUser } from '@/models/IUser.model';
import { IBooking } from '@/models/IBooking.model';

import Vue from 'vue'
import Vuex from 'vuex'

import { UsersAPI } from '../apis/users.api';
import { ParksAPI } from '../apis/parks.api';
import { BookingAPI } from '@/apis/bookings.api';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    
    user: null,
    users: [] as any[], 
    
    booking: null,
    bookings: [],

    park: null,
    parks:[],

    time: {
      date: new Date(),
      hour: new Date().getHours(),
    },
    
    clientType: '',

  } as IStore,

  mutations: {
    
    SET_USERS (state, users: IUser[]) {
      state.users = users;
      (window as any).users  = users;
    },
    SET_PARKS (state, parks: IPark[]) {
      state.parks = parks;
      (window as any).parks  = parks;
    },
    SET_PARK (state, park: IPark) {
      state.park = park;
      (window as any).park  = park;
    },
    SET_CLIENT_TYPE (state, clientType: string) {
      state.clientType = clientType;
      (window as any).clientType  = clientType;
    },
    SET_BOOKINGS (state, bookings: IBooking[]) {
      state.bookings = bookings;
      (window as any).bookings  = bookings;
    },
    SET_BOOKING (state, booking: IBooking) {
      state.booking = booking;
      (window as any).booking  = booking;
    },

    async SET_USER (state, user: IUser) {
      state.user = user;
      (window as any).user = user;
      return true;
    },
    async SET_TIME_DATE (state, date: Date) {
      state.time.date = date;
      return true;
    },
    async SET_TIME_HOUR (state, hour: number) {
      state.time.hour = hour;
      return true;
    },
  },
  actions: {

    async fetchUsers (context) {
      const api = new UsersAPI();
      const users: IUser[] = await api.getAll();
      context.commit('SET_USERS', users)
    },

 
    async fetchParks (context) {
      const api = new ParksAPI();
      const parks: IPark[] = await api.getAll();
      context.commit('SET_PARKS', parks)
    },
    

    setUser: ({commit}, payload) => {
      commit('SET_USER',  payload )
    },

    setParkById: async ({commit}, payload) => {
      const parkId = payload;
      const api = new ParksAPI();
      const parks: IPark[] = await api.getAll();
      const park = parks.find(park => park.name.replace(/[^A-Z0-9]+/ig, "_") === parkId)
      if(park) commit('SET_PARK', park )
      if(parks) commit('SET_PARKS', parks )
    },
    
    setPark: async ({commit}, payload) => {
      const park = payload;
      if(park) commit('SET_PARK', park )
    },
    
    fetchBookingByParkName: async({commit}, payload) => {
      const parkName = payload;
      const api = new BookingAPI();
      const bookings: IBooking[] = await api.getAllByParkName(parkName);
      if(parkName) commit('SET_BOOKINGS', bookings)
    },
    
    fetchBookingByDateAndParkAndCC : async({commit}, payload) => {

      const parkName = payload.parkName;
      const dateDDMMYYYY = payload.ddmmyyyy;
      const ccNumber = payload.cc;

      const api = new BookingAPI();
      const bookings: IBooking[] = await api.getByDateAndParkAndCC(dateDDMMYYYY, parkName, ccNumber);
      commit('SET_BOOKINGS', bookings)

    },

    fetchBookingById: async({commit}, payload) => {
      const bookingId = payload;
      const api = new BookingAPI();
      const booking: IBooking = await api.getById(bookingId);

      commit('SET_BOOKING', booking)
    },
    
    fetchUserByCC: async({commit}, payload) => {
      console.warn(' debuggin dispatch p2', payload)

      const cc = payload;
      console.warn(' debuggin dispatch p3', cc)

      const api = new UsersAPI();
      console.warn(' debuggin dispatch p4')

      const user = await api.getByCC(cc);
      console.warn(' debuggin dispatch p5', user)

      if(user) commit('SET_USER', user)
    },

    setClientType: ({commit}, payload) => {
      commit('SET_CLIENT_TYPE',  payload )
    },
    setTime: ({commit}, payload) => {
      if(payload.date){
        commit('SET_TIME_DATE', payload.date);
      }
      if(payload.hour){
        commit('SET_TIME_HOUR', payload.hour);
      }
    }
  },
  modules: {
  }
})
